export default __webpack_public_path__ + "static/media/calculator.dcefca36.png";